/**
 * Foreign voll-product (policy-business-api) Kafka topic names for the approval
 * flow — defined once so no integrator/agent inlines the raw strings.
 */
export const APPROVAL_TOPICS = Object.freeze({
  /** Inbound: a voucher awaits approval, with its resolved approvers. */
  requested: 'policy.approval.requested',
  /** Outbound: an approver approved. */
  successRegistered: 'policy.approval.success.registered',
  /** Outbound: an approver denied. */
  deniedRegistered: 'policy.approval.denied.registered',
} as const);

export type ApprovalTopic = (typeof APPROVAL_TOPICS)[keyof typeof APPROVAL_TOPICS];
